import React from "react";
import { ArrowRight, PhoneCall } from "lucide-react";
import { HERO_N, LINKS } from "../../data/mockNormal";

export default function NormalHero() {
  return (
    <section id="top" className="ocean-bg stars relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 right-0 w-[520px] h-[520px] rounded-full bg-[#1f6f8b]/25 blur-[120px] glow-pulse" />
      <div className="pointer-events-none absolute bottom-0 -left-20 w-[420px] h-[420px] rounded-full bg-[#5a5ee0]/20 blur-[120px] glow-pulse" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-24 md:pt-24 md:pb-32 grid lg:grid-cols-2 gap-10 items-center relative">
        <div>
          <p className="eyebrow text-[#7fd8e8] text-xs md:text-sm mb-4">{HERO_N.eyebrow}</p>
          <h1 className="text-5xl md:text-7xl leading-[0.95] font-semibold">
            <span className="block text-white">{HERO_N.title1}</span>
            <span className="block text-shimmer">{HERO_N.title2}</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-white/80 max-w-xl leading-relaxed">{HERO_N.subtitle}</p>
          <div className="mt-5 space-y-1.5 text-white/60">
            <p>{HERO_N.para1}</p>
            <p>{HERO_N.para2}</p>
          </div>
          <div className="mt-9 flex flex-wrap gap-4">
            <a href={LINKS.inscription} target="_blank" rel="noopener noreferrer" className="btn-gold rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2 group">
              Je réserve ma place maintenant
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href={LINKS.rdvClarte} target="_blank" rel="noopener noreferrer" className="btn-ghost rounded-full px-7 py-3.5 font-medium inline-flex items-center gap-2">
              <PhoneCall className="w-4 h-4" /> RDV Clarté
            </a>
          </div>
        </div>

        <div className="relative flex justify-center">
          <div className="absolute inset-0 m-auto w-[85%] h-[85%] rounded-full bg-gradient-to-tr from-[#1f6f8b]/40 to-[#5a5ee0]/30 blur-3xl glow-pulse" />
          <div className="relative float-anim">
            <img src={HERO_N.image} alt="Dauphins" className="w-[300px] md:w-[440px] rounded-full ring-1 ring-white/10 shadow-2xl" loading="eager" />
            <div className="absolute -bottom-3 -left-3 md:left-2 glass rounded-2xl px-5 py-3 float-soft">
              <div className="text-3xl font-semibold text-gold leading-none">14</div>
              <div className="text-[10px] uppercase tracking-widest text-white/60 mt-1">fréquences</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
